import 'css-chunksrc/client/pages/planzoneParametersPage/calendarsHolidays/defaultCalendarHolidays/styles.scss';export default {
  "calendarSelection": "_calendarSelection_kfrlo_1",
  "input": "_input_kfrlo_6",
  "selection": "_selection_kfrlo_23",
  "placeholder": "_placeholder_kfrlo_32",
  "list": "_list_kfrlo_37",
  "calendar": "_calendar_kfrlo_1",
  "iconBox": "_iconBox_kfrlo_65",
  "icon": "_icon_kfrlo_65",
  "opened": "_opened_kfrlo_78",
  "selectedCalendar": "_selectedCalendar_kfrlo_92",
  "selectedCalendarIcon": "_selectedCalendarIcon_kfrlo_96",
  "selectedCalendarTitle": "_selectedCalendarTitle_kfrlo_102"
};